import React from 'react';
import PropTypes from 'prop-types';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';

import { FinderAppManager } from 'apps/finder/appManager';
import { AutocompleteDropdown } from 'apps/finder/views/autocomplete';
import { NoFinderData } from 'apps/finder/views/noData';
import { ProjectsColumn } from 'apps/finder/views/projectsColumn';
import { FolderColumn } from 'apps/finder/views/folderColumn';
import { FileColumn } from 'apps/finder/views/fileColumn';

import {
  FinderWrapper,
  PathInputWrapper,
  SpinnerStyled,
  PathInput,
  FoldersSection,
  ColumsWrapper,
} from 'apps/finder/styles';

@observer
export class Finder extends React.Component {
  constructor(props) {
    super(props);
    this.manager = new FinderAppManager(this, props);
  }

  componentDidMount() {
    // FIXME - Current solution for preventing setting offsetLeft before new columns are in place
    reaction(
      () => this.manager.columns,
      () => {
        setTimeout(() => {
          this.columnsWrapperRef.scrollLeft += this.columnsWrapperRef.offsetWidth;
        }, 0);
      },
    );
  }

  render() {
    const {
      folders,
      input,
      projects,
      projectsQueryLoading,
      spaceQueryLoading,
    } = this.manager;
    const { OnInputChange } = this.manager;
    const { selectFileAction } = this.props;
    return (
      <FinderWrapper>
        <div
          ref={ref => {
            this.headerRef = ref;
          }}
        >
          <PathInputWrapper>
            <PathInput
              placeholder='Search for projects via their @username or +organisation'
              type='text'
              value={input}
              onChange={OnInputChange}
              ref={ref => {
                this.inputRef = ref;
              }}
              autoFocus
            />
            {spaceQueryLoading && <SpinnerStyled size='small' />}
          </PathInputWrapper>
          <AutocompleteDropdown
            manager={this.manager}
            parent={this.headerRef}
          />
        </div>
        {projects.length === 0 && !projectsQueryLoading ? (
          <NoFinderData manager={this.manager} inputRef={this.inputRef} />
        ) : (
          <ColumsWrapper
            ref={ref => {
              this.columnsWrapperRef = ref;
            }}
          >
            <ProjectsColumn manager={this.manager} />
            <FoldersSection>
              {folders.map((folder, i) => (
                <FolderColumn
                  key={i}
                  manager={this.manager}
                  folder={folder}
                  index={i}
                />
              ))}
            </FoldersSection>
            <FileColumn
              manager={this.manager}
              selectFileAction={selectFileAction}
            />
          </ColumsWrapper>
        )}
      </FinderWrapper>
    );
  }
}

Finder.propTypes = {
  selectFileAction: PropTypes.func,
};

/* Finder view is composed of search/path bar and multiple columns

- If the search/path bar is modified, re-run the queries and update the columns
- If a element of a column 'n' is selected, send the query for the column 'n+1'
*/
